import { type ExtensionUrl, extensionUrl } from "./index";
export const PATIENT_HOLDING_URL = extensionUrl("patient-registration-holding");

/** Every `Extension.url` this codebase defines itself. ADR-0022. */

export const ACTION_PARAMETER_VALUE_URL = extensionUrl("action-parameter-value");
export const ACTIVITY_DEFINITION_IDS_URL = extensionUrl("activity-definition-ids");
export const ACTIVITY_PARAMETER_URL = extensionUrl("activity-parameter");
export const ANNOTATION_RECIPIENT_URL = extensionUrl("annotation-recipient");
export const BLOCK_HIGH_WATER_URL = extensionUrl("schedule-block-id-high-water-mark");
export const CARE_PLAN_GOALS_URL = extensionUrl("care-plan-goals");
export const COUNTER_EXT_URL = extensionUrl("task-number-counter");
export const DOCUMENT_SOURCE_FILE_NAME_URL = extensionUrl("document-source-file-name");
export const ENCOUNTER_CLASS_URL = extensionUrl("encounter-class");
/** On a ClinicalImpression: what the note is about, as a `valueCode` from the domain's NOTE_CATEGORIES. */
export const NOTE_CATEGORY_URL = extensionUrl("note-category");
export const NOTE_SCHEMA_URL = extensionUrl("note-schema");
/** On a voided ClinicalImpression: the status it had when voided, which reinstating returns it to. */
export const NOTE_VOIDED_FROM_URL = extensionUrl("note-voided-from");
export const OBSERVATION_AUDIENCE_EXTENSION = extensionUrl("observation-audience");
export const OBSERVATION_SCHEMA_URL = extensionUrl("observation-schema");
export const ORDER_ID_URL = extensionUrl("order-identity");
export const ORDER_SOURCE_OCCURRENCE_URL = extensionUrl("order-source-occurrence");
export const PERFORMER_TYPE_URL = extensionUrl("performer-type");
export const PREFS_MUTED_EXTENSION_URL = extensionUrl("notify-prefs-muted-kinds");
export const PROCEDURE_NOTE_CONFIG_URL = extensionUrl("procedure-note-config");
export const PROTOCOL_MEMBER_ID_URL = extensionUrl("protocol-member-id");
export const PROTOCOL_SCHEDULING_URL = extensionUrl("protocol-scheduling");
export const QUESTIONNAIRE_INSTANCE_PROFILE = extensionUrl("questionnaire-instance");
export const REQUIRED_RESOURCE_URL = extensionUrl("required-resource");
export const ROLE_EXTENSION_URL = extensionUrl("practitioner-role");
export const SOAP_HINT_URL = extensionUrl("soap-hint");
export const SUPPORTS_CONDITIONS_URL = extensionUrl("supports-conditions");
export const TASK_PARAMETER_VALUE_URL = extensionUrl("task-parameter-value");
export const TASK_SORT_ORDER_URL = extensionUrl("task-sort-order");
export const TIME_WINDOW_URL = extensionUrl("time-window");
export const TREATMENT_CATEGORY_URL = extensionUrl("treatment-category");
export const WORKFLOW_EPISODE_OF_CARE_URL = extensionUrl("workflow-episode-of-care");

export const EXTENSION_URLS: readonly ExtensionUrl[] = [
  PATIENT_HOLDING_URL,
  ACTION_PARAMETER_VALUE_URL,
  ACTIVITY_DEFINITION_IDS_URL,
  ACTIVITY_PARAMETER_URL,
  ANNOTATION_RECIPIENT_URL,
  BLOCK_HIGH_WATER_URL,
  CARE_PLAN_GOALS_URL,
  COUNTER_EXT_URL,
  DOCUMENT_SOURCE_FILE_NAME_URL,
  ENCOUNTER_CLASS_URL,
  NOTE_CATEGORY_URL,
  NOTE_SCHEMA_URL,
  NOTE_VOIDED_FROM_URL,
  OBSERVATION_AUDIENCE_EXTENSION,
  OBSERVATION_SCHEMA_URL,
  ORDER_ID_URL,
  ORDER_SOURCE_OCCURRENCE_URL,
  PERFORMER_TYPE_URL,
  PREFS_MUTED_EXTENSION_URL,
  PROCEDURE_NOTE_CONFIG_URL,
  PROTOCOL_MEMBER_ID_URL,
  PROTOCOL_SCHEDULING_URL,
  QUESTIONNAIRE_INSTANCE_PROFILE,
  REQUIRED_RESOURCE_URL,
  ROLE_EXTENSION_URL,
  SOAP_HINT_URL,
  SUPPORTS_CONDITIONS_URL,
  TASK_PARAMETER_VALUE_URL,
  TASK_SORT_ORDER_URL,
  TIME_WINDOW_URL,
  TREATMENT_CATEGORY_URL,
  WORKFLOW_EPISODE_OF_CARE_URL,
];

export const OBSERVATION_LEVEL_URL = extensionUrl("procedure-observation-level");

export const RELATED_PERSON_PORTAL_GRANT_URL = extensionUrl("related-person-portal-grant");

export const PATIENT_FACT_CONDITION_URL = extensionUrl("patient-fact-condition");

export const PATIENT_PORTAL_GRANT_URL = extensionUrl("patient-portal-grant");

export const PATIENT_CONSENTED_URL = extensionUrl("patient-consented");
export const TRIAL_PLANNED_TRIAL_URL = extensionUrl("trial-planned-trial");
